import React from "react";

const MediaPreview = React.memo(({ previewFiles = [], onRemove }) => {
  if (!previewFiles || previewFiles.length === 0) return null;

  return (
    <div className="preview-section">
      {previewFiles.map((preview, index) => (
        <div key={index} className="preview-item">
          {preview.type.startsWith("image/") && (
            <img src={preview.url} alt={`Preview ${index}`} />
          )}
          {preview.type.startsWith("video/") && (
            <video src={preview.url} controls />
          )}
          {preview.type.startsWith("audio/") && (
            <audio src={preview.url} controls />
          )}
          <button className="btn delete-btn" onClick={() => onRemove(index)}>
            Cancella
          </button>
        </div>
      ))}
    </div>
  );
});

export default MediaPreview;
